import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/data";

const ease = [0.22, 1, 0.36, 1];

export default function Manifesto() {
  return (
    <section
      id="chapters"
      data-testid="manifesto-section"
      className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-40"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-14 md:mb-24">
        <div className="col-span-12 md:col-span-3">
          <div className="overline text-[color:var(--ink-soft)]">§ Manifesto</div>
        </div>
        <div className="col-span-12 md:col-span-9">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.0, ease }}
            className="font-serif-display leading-[0.95] tracking-tight"
            style={{ fontSize: "clamp(36px, 5vw, 76px)" }}
          >
            Four beliefs we keep,{" "}
            <span className="font-italic-serif italic text-[color:var(--ink-soft)]">
              underlined in the ledger.
            </span>
          </motion.h2>
        </div>
      </div>

      <div className="rule-strong" />

      <div>
        {MANIFESTO.map((ch, i) => (
          <motion.article
            key={ch.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: i * 0.05, ease }}
            className="grid grid-cols-12 gap-6 md:gap-10 py-10 md:py-16 border-b border-[color:var(--ink-line)] group"
            data-testid={`manifesto-chapter-${ch.n}`}
          >
            <div className="col-span-12 md:col-span-3">
              <div className="chapter-num text-[color:var(--ink)] group-hover:text-[color:var(--rust)] transition-colors duration-500">
                {ch.n}
              </div>
            </div>
            <div className="col-span-12 md:col-span-6">
              <h3
                className="font-serif-display leading-[1.02] tracking-tight"
                style={{ fontSize: "clamp(28px, 3.4vw, 48px)" }}
              >
                {ch.title}
              </h3>
            </div>
            <div className="col-span-12 md:col-span-3">
              <p className="text-[15px] leading-[1.6] text-[color:var(--ink-soft)]">
                {ch.body}
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
